import { Card, CardContent, Typography, Button, Stack } from '@mui/material';
import CustomCard from '../../../../components/ui/customCard';

export function AudienceSegments() {
  return (
    <CustomCard>
      <CardContent>
        <Typography fontWeight="bold" mb={2}>
          Segments clés
        </Typography>

        <Stack spacing={2}>
          <Button variant="outlined">
            🎯 Fans réguliers
          </Button>
          <Button variant="outlined">
            💎 Acheteurs premium
          </Button>
          <Button variant="outlined">
            💤 Inactifs (90j)
          </Button>
        </Stack>
      </CardContent>
    </CustomCard>
  );
}
